var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconReload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_638_31719)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6654 6.41837C11.5227 5.39183 11.0465 4.44067 10.3101 3.71141C9.57365 2.98214 8.61789 2.51524 7.59001 2.38261C6.56212 2.24998 5.51914 2.45898 4.62173 2.97743C3.72432 3.49587 3.02226 4.295 2.6237 5.2517M2.33203 2.91837V5.2517H4.66536",
    stroke: "#5A6680",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.33203 7.58203C2.47469 8.60857 2.95091 9.55973 3.68733 10.289C4.42374 11.0183 5.37951 11.4852 6.40739 11.6178C7.43527 11.7504 8.47825 11.5414 9.37566 11.023C10.2731 10.5045 10.9751 9.7054 11.3737 8.7487M11.6654 11.082V8.7487H9.33203",
    stroke: "#5A6680",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_638_31719"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReload);
export default __webpack_public_path__ + "static/media/icon-reload.38e7b0edf1053839b97a9de7c10a66f9.svg";
export { ForwardRef as ReactComponent };